<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>

          <OLoadingDialog :value="isLoading"/>

          <v-card>
            <v-toolbar flat class="card-bar">
              <v-toolbar-title>SysConfigs</v-toolbar-title>
              <v-btn icon @click="reload" class="ml-2">
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-toolbar>

            <ODataTable
              :items="rows"
              :spec="spec"/>

            <v-card-text>
              <v-textarea
                class="monospace-input"
                v-model="input"
                label="Alterar Configs"
                :hint="`(uma por linha, separada por '='. Para apagar, use 'x=')`">
              </v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" large
                @click="save()">Save</v-btn>
            </v-card-actions>
          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import {SysConfig} from '@/models'
import ODataTable from 'oderon-vue/cpts/ODataTable'
import OLoadingDialog from 'oderon-vue/cpts/OLoadingDialog'

export default {
  components: {ODataTable, OLoadingDialog},
  data() {
    return {
      isLoading: false,
      input: '',
      rows: [],
      spec: [
        {t: 'Chave', d: 'code'  , w: 300},
        {t: 'Valor', d: 'value'}
      ]
    }
  },
  mounted() { this.reload() },
  methods: {
    reload() { this.$loading(() => this.fetchData()) },
    async fetchData() {
      let cfgs = await SysConfig.findAll()
      this.rows = _.chain(cfgs)
        .map((v, k) => ({code: k, value: v}))
        .sortBy('code').value()
    },
    save() {
      let lines = _.compact(this.input.split('\n').map(l => l.trim())),
          obj = {}

      _.forEach(lines, l => {
        let pieces = l.split('='),
            k = pieces[0].trim(),
            v = pieces[1] ? pieces[1].trim() : null
        obj[k] = v
      })

      this.$loading(async () => {
        this.input = ''
        await SysConfig.save(obj)
        await this.fetchData()
      })
    }
  }
}

</script>

<style>
</style>
